import React, { ReactElement } from 'react'

import { SectionSubtitles } from './styles'

const SectionSubtitle = ({
  fontSize,
  fontWeight,
  id,
  classSub,
  lineHeight,
  textAlign,
  children,
  onClick,
  ...props
}: {
  fontSize?: number
  fontWeight?: number
  id?: string
  classSub?: string
  lineHeight?: number
  textAlign?: string
  children?: ReactElement | string | string[]
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: any
} & React.HTMLProps<HTMLDivElement>) => {
  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  return (
    <SectionSubtitles
      id={id}
      className={classSub}
      fontSize={fontSize}
      fontWeight={fontWeight}
      $lineHeight={lineHeight}
      $textAlign={textAlign}
      onClick={onClick ? handleClick : undefined}
      {...props}
    >
      {children}
    </SectionSubtitles>
  )
}

export default SectionSubtitle
